import debug from 'debug';
import Debounce from 'Global/Shared/Components/Debounce/Debounce';
import Spinner from 'Minetilbud/Shared/Components/spinner/spinner';

const log = debug('InspirationProductsByCategory:Events:ProductLoader');
const debounce = new Debounce().debounce;
const spinner = new Spinner();

class ProductLoader {
	constructor(element) {
		this.element = element;

		this.scrollEvent = this.scrollHandler.bind(this);
		this.scrollHandler = debounce(this.scrollHandler, 250);

		this.initialize();
	}

	eventListeners() {
		document.addEventListener('scroll', this.scrollEvent, true);
	}

	/**
	 * @param {string} imageUrl
	 * @param {boolean} isPriority
	 * 
	 * @returns {Promise} image
	 */
	 async getImage({ aspectRatio, imageUrl }) {
		return new Promise((resolve, reject) => {
			
			const scale = window.devicePixelRatio;
			const imageSize = 118;
			
			const dimension = aspectRatio < 1 ? 'w' : 'h';
			const separator = imageUrl.indexOf('?') !== -1 ? '&' : '?';

			const url = `${imageUrl}${separator}${dimension}=${imageSize * scale}`;
			let newUrl = '';
			
			const image = document.createElement('img');
	
			image.onload = () => {
				if (newUrl !== '') {
					resolve({ image, aspectRatio: image.height / image.width });
				} else if (aspectRatio === 0 && image.height > imageSize * scale) {
					newUrl = `${imageUrl}${separator}h=${imageSize * scale}`;
					image.src = newUrl;
				} else {
					resolve({ image, aspectRatio: image.height / image.width });
				}
			}

			image.onerror = (error) => {
				log('getImage() ERROR', error);
			}
			
			image.src = url;
		});
	}

	async initialize() {
		this.eventListeners();
		this.setup();
	}

	isInView() {
		const elementRect = this.element.getBoundingClientRect();

		if ((elementRect.top > 0 || elementRect.bottom > 0) && elementRect.top < window.innerHeight) {
			return true;
		};

		return false;
	}

	/**
	 * @param {any} id
	 * 
	 * @returns {boolean}
	 */
	 isLoaded(id) {
		if (this.loaded !== undefined && this.loaded.indexOf(id) > -1) return true;
		if (this.loaded === undefined) this.loaded = [];
		
		this.loaded.push(id);

		return false
	}

	/**
	 * @param {Object} product
	 * @param {Element} productElement
	 */
	async render(productElement) {
		productElement.innerHTML = '';
		productElement.insertAdjacentHTML('beforeend', spinner.use('o-inspiration-products__image-spinner'));

		const aspectRatio = parseInt(productElement.getAttribute('data-aspect-ratio'), 10);
		const imageUrl = productElement.getAttribute('data-image-url');
		const title = productElement.getAttribute('data-title');

		const response = await this.getImage({ 
			aspectRatio,
			imageUrl
		});

		productElement.innerHTML = '';

		const productImage = response.image;
		productImage.setAttribute('class', 'o-inspiration-products__image');
		productImage.setAttribute('alt', title);
		
		productImage.setAttribute('width', 118);
		productImage.setAttribute('height', 118);

		if (response.aspectRatio > 1) {
			productImage.setAttribute('width', 118 / response.aspectRatio);
		} else if (response.aspectRatio < 1) {
			productImage.setAttribute('height', 118 * response.aspectRatio);
		}

		productElement.appendChild(productImage);
	}

	scrollHandler() {
		this.setup();
	}

	async setup() {
		if (this.isInView() === false) return;

		const products = this.element.querySelectorAll('[data-js="inspiration-products__image-loader"]');

		products.forEach(element => {
			const productId = element.getAttribute('data-id');
			if (this.isLoaded(productId)) { 
				return;
			}

			this.render(element);
		});
	}
}

export default ProductLoader;
